import React, { useEffect, useRef } from "react";

import "../css/imageslider.css";

import GalleryCards from "./GalleryCards";

const HiSlide = () => {
  return (
    <>
      <GalleryCards />
    </>
  );
};

export default HiSlide;
